import config from 'config'
import { getJsonHeaders } from './helpers'

export async function get(screenId) {
  const res = await fetch(config.API_URL + `/iapi/screens/${screenId}/widget-settings`, {
    method: 'GET',
    headers: await getJsonHeaders(),
    credentials: 'include',
  })

  return {
    success: res.status === 200,
    data: await res.json(),
  }
}

export async function update(screenId, body) {
  const res = await fetch(config.API_URL + `/iapi/screens/${screenId}/widget-settings`, {
    method: 'PUT',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return {
    success: res.status === 200,
    data: await res.json(),
  }
}
